module.exports = __webpack_public_path__ + "assets/img/star_sentence_un6.dfcaa05d.png";